import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'lb-divider',
	standalone: true,
	imports: [CommonModule],
	template: '<div [ngClass]="orientation"></div>',
	styleUrls: ['./divider.component.scss']
})
export class DividerComponent {
	@Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
}
